import { Component } from "@angular/core";
import { OffCanvasChildComponent } from "src/app/model/off-canvas-child-component";
import { OffCanvasService } from '../../services';

@Component(
    {
        templateUrl: './info-pricing-update.component.html',
        styleUrls: ['info-pricing-update.scss']
    }
)
export class InfoPricingUpdateComponent extends OffCanvasChildComponent
{
    public constructor(offCanvasService: OffCanvasService)
    {
        super(offCanvasService);
    }
}
